import axios from "./axios";

export async function fetchHistories(controller) {
  return axios({ method: "get", url: "/histories/", params: controller });
}
